<template>
  <v-chip class="chip__grid" color="#E3F2FD" text-color="#2196F3" small label>
    <v-icon x-small left> mdi-shield </v-icon>
    <strong>{{ numberOfPermissions }} </strong>
  </v-chip>
</template>

<script>
// import axios from "@/axios";
// import { mapActions } from "vuex";

export default {
  name: "ProfilePermissionsComponent",

  data: () => ({
    // numberOfPermissions: "...",
  }),

  props: {
    resource: {
      type: Object,
      require: true,
    },

    abilities: {
      type: Array,
      default: () => [],
    },
  },

  // watch: {
    // resource: {
    //   handler() {
    //     // this.getInformations();
    //   },
    //   immediate: true,
    // },
  // },

  computed: {
    numberOfPermissions() {
       return this.abilities ? this.abilities.length : 0;
    },
  },

  // mounted() {
  //   this.getInformations();
  // },

  methods: {
    // ...mapActions(["changeProfileAbilitiesInfo"]),

    // VER SOBRE ROTAS
    // Rota retorna um perfil e as suas habilidades ->
    // GET: /profile/{id}/abilities
    // sendo que o {id} é equivalente ao id do perfil.
    // async getInformations() {
    //   try {
    //     const { data } = await axios.get(
    //       `/profile/${this.resource.id}/abilities`
    //     );
    //     // conta quantas permissões esse perfil tem
    //     this.numberOfPermissions = data.abilities ? data.abilities.length : 0;
    //   } catch (error) {
    //     console.error("Erro ao carregar habilidades:", error);
    //     this.numberOfPermissions = 0;
    //   }
    // },
    // refresh() {
      // this.getInformations();
    // },
  },
};
</script>

<style lang="scss" scoped>
.chip__grid {
  display: flex;
  align-content: center;
  justify-content: center;
  gap: 0;
  height: 28px;
  min-width: 80px;
  width: fit-content;
  border-radius: 10px !important;
}
</style>
